import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import { isDwellerRole } from '../../../../../utils/user'
import { MINIMIZED_MODAL_SCOPE } from '../../../../Modal'
import {
  REQUEST_FORM_FIELD_NAME_APPLICANT,
  REQUEST_FORM_FIELD_NAME_RELATED_REQUESTS,
  REQUEST_FORM_INITIAL_VALUES,
  toRequestFormApplicantSelectOption,
  toRequestSelectItem,
  useCreateRequest,
} from '../../../../Request'
import { toUserSelectItem } from '../../../../User'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileCreateServiceRequestAction() {
  const { handleReloadAfterChange, requestData, setModal } =
    useRequestProfileContext()

  async function handleReloadAfterCreate() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.relatedRequests)
  }

  const { handleOpenCreation } = useCreateRequest({
    minimizedModalScope: MINIMIZED_MODAL_SCOPE.REQUEST_PROFILE,
    setModal,
    onReload: handleReloadAfterCreate,
  })

  function handleClickCreateServiceRequest() {
    const { owner } = requestData

    const isOwnerDweller = Boolean(owner) && isDwellerRole(owner)

    handleOpenCreation({
      formProps: {
        initialValues: {
          ...REQUEST_FORM_INITIAL_VALUES,
          ...(isOwnerDweller
            ? { [REQUEST_FORM_FIELD_NAME_APPLICANT]: toUserSelectItem(owner) }
            : null),
          [REQUEST_FORM_FIELD_NAME_RELATED_REQUESTS]: [
            toRequestSelectItem(requestData),
          ],
        },
      },
      wizardProps: {
        ...(isOwnerDweller
          ? { initialUser: toRequestFormApplicantSelectOption(owner) }
          : null),
        originalRequestId: requestData.id,
      },
    })
  }

  return { handleClickCreateServiceRequest }
}
